export const msgEn = {
    channel: 'Channel',
    ment: 'Ment',

    api_fail: 'Fail to Connect Server',
    json_fail: 'Fail to Convert Json Data',
};


// WEBPACK FOOTER //
// ./src/vars/msg/en.js